import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme, { colors: any }>((theme) => ({
  main: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    paddingTop: 111,
    paddingBottom: 20,
  },
  formSearch: {
    borderRadius: 4,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 0,
    margin: 0,
    backgroundColor: (props) => props.colors.searchInputColor,
    border: '1px solid #192844',
    transition: 'all 0.3s ease',
    '&:focus-within': {
      border: (props) => `1px solid ${props.colors.colorWithoutGradient}`,
      boxShadow: (props) => `0 0 8px ${props.colors.colorWithoutGradient}40`,
    },
  },
  formSearchError: {
    border: '1px solid #f44336 !important',
    '&:focus-within': {
      border: '1px solid #f44336 !important',
      boxShadow: '0 0 8px rgba(244, 67, 54, 0.25)',
    },
  },
  boxInput: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  iconButton: {
    borderRadius: 0,
    color: (props) => props.colors.textBody,
    minWidth: 50,
    textAlign: 'center',
    margin: '11px 16px',
  },
  inputSearch: {
    width: '100%',
    height: 64,
    outline: 'none',
    paddingLeft: 16,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 400,
    borderRadius: 4,
    border: 'none',
    color: (props) => props.colors.textBody,
    fontStyle: 'italic',
    backgroundColor: 'transparent',
    transition: 'all 0.3s ease',
    '& input': {
      fontWeight: 400,
      fontStyle: 'italic',
      fontSize: 14,
    },
    '& input::placeholder': {
      color: (props) => props.colors.textBody,
      opacity: 1,
      fontWeight: 400,
      fontStyle: 'italic',
      fontSize: 14,
    },
    '&::placeholder': {
      color: (props) => props.colors.textBody,
      fontWeight: 400,
      fontStyle: 'italic',
      fontSize: 14,
    },
  },
  inputError: {
    '& input::placeholder': {
      color: '#f44336 !important',
      fontWeight: 500,
      opacity: 1,
    },
    '&::placeholder': {
      color: '#f44336 !important',
      fontWeight: 500,
    },
  },
  titleSearch: {
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(36),
    textAlign: 'center',
    textTransform: 'uppercase',
    color: (props) => props.colors.colorSecondary,
    fontFamily: 'Roboto',
    margin: 0,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  textLegend: {
    color: '#FFF',
    fontFamily: 'Roboto',
    fontWeight: 500,
    textTransform: 'capitalize',
    fontSize: 16,
    textShadow: '#000 0.1em 0.1em 0.2em',
  },
  boxButtonSearch: {
    width: 86,
    height: 42,
    borderRadius: 5,
    backgroundColor: (props) => props.colors.colorWithoutGradient,
    margin: '0px 12px',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
    '&:hover': {
      backgroundColor: '#472774',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  buttonSearchText: {
    padding: '11px 19px',
    color: '#fff',
    fontSize: 14,
    fontWeight: 400,
    textTransform: 'uppercase',
  },
  buttonMobile: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: 12,
    backgroundColor: (props) => props.colors.colorWithoutGradient,
    border: 'none',
    marginTop: 12,
    maxWidth: 720,
    borderRadius: 5,
    cursor: 'pointer',
    margin: '0px 20px',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
    '&:hover': {
      backgroundColor: (props) => props.colors.colorWithoutGradient,
      filter: 'brightness(0.9)',
    },
    [theme.breakpoints.up('xs')]: {
      display: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
    },
  },
  textSearchMobile: {
    textTransform: 'uppercase',
    color: '#fff',
    fontFamily: 'Roboto',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
  },
  box: {
    margin: '0px 20px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 24,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
  },
  arrowIcon: {
    color: (props) => props.colors.colorSecondary,
    fontSize: '2.5rem',
  },
  iconSearch: {
    width: 40,
    height: 40,
    color: (props) => props.colors.borderShadowColorSecondary,
  },
  errorText: {
    color: '#f44336',
    fontSize: theme.typography.pxToRem(12),
    marginTop: 4,
    paddingLeft: 16,
    fontFamily: 'Roboto',
  },
}))
